var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwarded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.583 11.172v-5H8v-2.5l5.417 5-5.417 5v-2.5H2.583z",
    fill: "#386EE7"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yLjU4MzMxIDExLjE3MTlWNi4xNzE4OEg3Ljk5OTk4VjMuNjcxODhMMTMuNDE2NiA4LjY3MTg4TDcuOTk5OTggMTMuNjcxOVYxMS4xNzE5SDIuNTgzMzFaIiBmaWxsPSIjMzg2RUU3Ii8+CiAgICA8L3N2Zz4KICAgIA==";
export { SvgForwarded as ReactComponent };